/* eslint-disable eqeqeq */
import React from "react";
import { NOTIFICATION_TYPE } from "./constants";

const ItemBody20 = ({ notification }) => {
  const getBody = () => {
    if (notification?.type == NOTIFICATION_TYPE.TRIP_CHECKLIST_FAILED) {
      return (
        <p className="font-poppins text-xs font-light">
          Pre-trip checklist failed for vehicle{" "}
          <span className="font-medium">
            {notification?.metaData?.trikeRegistrationNo}
          </span>{" "}
          assigned to trip ID{" "}
          <span className="font-medium">{notification?.metaData?.tripId}</span>
        </p>
      );
    }

    if (notification?.type == NOTIFICATION_TYPE.SESSION_CHECKLIST_FAILED) {
      return (
        <p className="font-poppins text-xs font-light">
          Pre-session checklist failed for asset{" "}
          <span className="font-medium">
            {notification?.metaData?.assetRegistrationNo}
          </span>{" "}
          assigned to session ID{" "}
          <span className="font-medium">
            {notification?.metaData?.sessionId}
          </span>
        </p>
      );
    }

    if (notification?.type == NOTIFICATION_TYPE.RENTAL_CHECKLIST_FAILED) {
      return (
        <p className="font-poppins text-xs font-light">
          Pre-rental checklist failed for vehicle{" "}
          <span className="font-medium">
            {notification?.metaData?.trikeRegistrationNo}
          </span>{" "}
          assigned to rental ID{" "}
          <span className="font-medium">
            {notification?.metaData?.rentalId}.
          </span>
        </p>
      );
    }

    return null;
  };

  return <div>{getBody()}</div>;
};

export default ItemBody20;
